module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-col', {
    staticClass: "toolbar uptool noheight",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    },
    on: {
      "click": _vm.DownForSearch
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', [_c('el-button', {
    staticStyle: {
      "margin-left": "10px",
      "color": "#000",
      "cursor": "auto"
    },
    attrs: {
      "type": "text",
      "size": "small"
    }
  }, [_vm._v("姓名:")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "clearable": "",
      "placeholder": "请输入内容",
      "size": "mini"
    },
    model: {
      value: (_vm.CustName),
      callback: function($$v) {
        _vm.CustName = $$v
      },
      expression: "CustName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    staticStyle: {
      "margin-left": "10px",
      "color": "#000",
      "cursor": "auto"
    },
    attrs: {
      "type": "text",
      "size": "small"
    }
  }, [_vm._v("电话:")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "clearable": "",
      "placeholder": "请输入内容",
      "size": "mini"
    },
    model: {
      value: (_vm.CustPhone),
      callback: function($$v) {
        _vm.CustPhone = $$v
      },
      expression: "CustPhone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    staticStyle: {
      "margin-left": "10px",
      "color": "#000",
      "cursor": "auto"
    },
    attrs: {
      "type": "text",
      "size": "small"
    }
  }, [_vm._v("地址:")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-cascader', {
    attrs: {
      "size": "mini",
      "expand-trigger": "hover",
      "options": _vm.Addoptions
    },
    on: {
      "change": _vm.SelectChange
    },
    model: {
      value: (_vm.AddrSelect),
      callback: function($$v) {
        _vm.AddrSelect = $$v
      },
      expression: "AddrSelect"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form', {
    attrs: {
      "inline": true
    }
  }, [_c('el-button', {
    staticStyle: {
      "margin-left": "10px",
      "color": "#000",
      "cursor": "auto"
    },
    attrs: {
      "type": "text",
      "size": "small"
    }
  }, [_vm._v("出生日期:")]), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "size": "mini",
      "unlink-panels": "",
      "type": "daterange",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期",
      "format": "yyyy 年 MM 月 dd 日 ",
      "value-format": "timestamp"
    },
    model: {
      value: (_vm.BirthTime),
      callback: function($$v) {
        _vm.BirthTime = $$v
      },
      expression: "BirthTime"
    }
  }), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "10px",
      "color": "#000",
      "cursor": "auto"
    },
    attrs: {
      "type": "text",
      "size": "small"
    }
  }, [_vm._v("受伤日期:")]), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "size": "mini",
      "unlink-panels": "",
      "type": "daterange",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期",
      "format": "yyyy 年 MM 月 dd 日",
      "value-format": "timestamp"
    },
    model: {
      value: (_vm.HurtTime),
      callback: function($$v) {
        _vm.HurtTime = $$v
      },
      expression: "HurtTime"
    }
  })], 1), _vm._v(" "), _c('el-form', {
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', [_c('el-button', {
    staticStyle: {
      "margin-left": "10px",
      "color": "#000",
      "cursor": "auto"
    },
    attrs: {
      "type": "text",
      "size": "small"
    }
  }, [_vm._v("身高(cm):")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "placeholder": "请输入内容",
      "size": "mini"
    },
    model: {
      value: (_vm.CustHeight1),
      callback: function($$v) {
        _vm.CustHeight1 = $$v
      },
      expression: "CustHeight1"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    staticStyle: {
      "color": "#000",
      "cursor": "auto"
    },
    attrs: {
      "type": "text",
      "size": "small"
    }
  }, [_vm._v("~")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "placeholder": "请输入内容",
      "size": "mini"
    },
    model: {
      value: (_vm.CustHeight2),
      callback: function($$v) {
        _vm.CustHeight2 = $$v
      },
      expression: "CustHeight2"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    staticStyle: {
      "margin-left": "10px",
      "color": "#000",
      "cursor": "auto"
    },
    attrs: {
      "type": "text",
      "size": "small"
    }
  }, [_vm._v("体重(kg):")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "placeholder": "请输入内容",
      "size": "mini"
    },
    model: {
      value: (_vm.CustWeight1),
      callback: function($$v) {
        _vm.CustWeight1 = $$v
      },
      expression: "CustWeight1"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    staticStyle: {
      "color": "#000",
      "cursor": "auto"
    },
    attrs: {
      "type": "text",
      "size": "small"
    }
  }, [_vm._v("~")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "placeholder": "请输入内容",
      "size": "mini"
    },
    model: {
      value: (_vm.CustWeight2),
      callback: function($$v) {
        _vm.CustWeight2 = $$v
      },
      expression: "CustWeight2"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    staticStyle: {
      "margin-left": "10px",
      "color": "#000",
      "cursor": "auto"
    },
    attrs: {
      "type": "text",
      "size": "small"
    }
  }, [_vm._v("腰围cm:")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "placeholder": "请输入内容",
      "size": "mini"
    },
    model: {
      value: (_vm.CustWaitLine1),
      callback: function($$v) {
        _vm.CustWaitLine1 = $$v
      },
      expression: "CustWaitLine1"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    staticStyle: {
      "color": "#000",
      "cursor": "auto"
    },
    attrs: {
      "type": "text",
      "size": "small"
    }
  }, [_vm._v("~")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "placeholder": "请输入内容",
      "size": "mini"
    },
    model: {
      value: (_vm.CustWaitLine2),
      callback: function($$v) {
        _vm.CustWaitLine2 = $$v
      },
      expression: "CustWaitLine2"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "el-icon-search",
      "size": "mini"
    },
    on: {
      "click": _vm.Find
    }
  }, [_vm._v("搜索")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "info",
      "size": "mini"
    },
    on: {
      "click": _vm.rest
    }
  }, [_vm._v("重置")])], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "padding-bottom": "10px",
      "text-align": "center",
      "color": "#999"
    },
    attrs: {
      "span": 24
    }
  }, [_c('span', [_vm._v(">> ")]), _c('span', {
    staticClass: "downsearch",
    on: {
      "click": _vm.DownForSearch
    }
  }, [_vm._v("点击下拉")]), _c('span', [_vm._v(" <<")])]), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listloading),
      expression: "listloading"
    }],
    staticStyle: {
      "width": "99.9%"
    },
    attrs: {
      "data": _vm.List,
      "border": "",
      "max-height": _vm.maxHeight,
      "id": "OnlyBox"
    },
    on: {
      "filter-change": _vm.Filterfind,
      "row-dblclick": _vm.ChangeIt
    }
  }, [_c('el-table-column', {
    attrs: {
      "fixed": "",
      "label": "序号",
      "width": "50",
      "prop": "sNumber"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "姓名",
      "prop": "name",
      "fixed": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "录入时间",
      "fixed": "",
      "prop": "created_at",
      "width": "100",
      "formatter": _vm.dateFormat2
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "性别",
      "prop": "gender",
      "width": "65",
      "column-key": "gender",
      "filters": _vm.Agender
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.gender == 1) ? _c('span', [_vm._v("男")]) : _vm._e(), _vm._v(" "), (scope.row.gender == 2) ? _c('span', [_vm._v("女")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "出生年月",
      "prop": "birth",
      "width": "78",
      "formatter": _vm.dateFormat3
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "身高(cm)",
      "prop": "height",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "体重(kg)",
      "prop": "weight",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "腰围(cm)",
      "prop": "waist",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "学历",
      "prop": "edu",
      "width": "65",
      "column-key": "edu",
      "filters": _vm.Aedu
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "职业",
      "prop": "job",
      "width": "70",
      "column-key": "job",
      "filters": _vm.Ajob
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.gender == 1) ? _c('span', [_vm._v("无")]) : _vm._e(), _vm._v(" "), (scope.row.gender == 2) ? _c('span', [_vm._v("学生")]) : _vm._e(), _vm._v(" "), (scope.row.gender == 3) ? _c('span', [_vm._v("文化/艺术")]) : _vm._e(), _vm._v(" "), (scope.row.gender == 4) ? _c('span', [_vm._v("影视/娱乐")]) : _vm._e(), _vm._v(" "), (scope.row.gender == 5) ? _c('span', [_vm._v("金融")]) : _vm._e(), _vm._v(" "), (scope.row.gender == 6) ? _c('span', [_vm._v("医药/健康")]) : _vm._e(), _vm._v(" "), (scope.row.gender == 7) ? _c('span', [_vm._v("工业/制造业")]) : _vm._e(), _vm._v(" "), (scope.row.gender == 8) ? _c('span', [_vm._v("建筑")]) : _vm._e(), _vm._v(" "), (scope.row.gender == 9) ? _c('span', [_vm._v("司机")]) : _vm._e(), _vm._v(" "), (scope.row.gender == 10) ? _c('span', [_vm._v("公职")]) : _vm._e(), _vm._v(" "), (scope.row.gender == 11) ? _c('span', [_vm._v("IT/互联网/通信")]) : _vm._e(), _vm._v(" "), (scope.row.gender == 12) ? _c('span', [_vm._v("媒体/公关")]) : _vm._e(), _vm._v(" "), (scope.row.gender == 13) ? _c('span', [_vm._v("零售")]) : _vm._e(), _vm._v(" "), (scope.row.gender == 14) ? _c('span', [_vm._v("教育/科研")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "受伤时间",
      "prop": "injurytime",
      "width": "78",
      "formatter": _vm.dateFormat3
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "电话",
      "prop": "phone",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "常住地",
      "prop": "addr",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "脊柱损伤"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "颈椎段",
      "width": "100",
      "prop": "AQ1",
      "column-key": "AQ11",
      "filters": _vm.AQ11Filt
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-popover', {
          attrs: {
            "trigger": "hover",
            "placement": "top"
          }
        }, [_c('p', _vm._l((scope.row.AQ101), function(item) {
          return _c('span', [(item == 17) ? _c('span', [_vm._v("C2~C3")]) : _vm._e(), _vm._v(" "), (item == 18) ? _c('span', [_vm._v("C3~C4")]) : _vm._e(), _vm._v(" "), (item == 19) ? _c('span', [_vm._v("C4~C5")]) : _vm._e(), _vm._v(" "), (item == 20) ? _c('span', [_vm._v("C5~C6")]) : _vm._e(), _vm._v(" "), (item == 21) ? _c('span', [_vm._v("C6~C7")]) : _vm._e(), _vm._v(" "), (item == 22) ? _c('span', [_vm._v("C7~C8")]) : _vm._e()])
        })), _vm._v(" "), _c('div', {
          staticClass: "name-wrapper",
          attrs: {
            "slot": "reference"
          },
          slot: "reference"
        }, [(scope.row.AQ101[0] == 17) ? _c('span', [_vm._v("C2~C3")]) : _vm._e(), _vm._v(" "), (scope.row.AQ101[0] == 18) ? _c('span', [_vm._v("C3~C4")]) : _vm._e(), _vm._v(" "), (scope.row.AQ101[0] == 19) ? _c('span', [_vm._v("C4~C5")]) : _vm._e(), _vm._v(" "), (scope.row.AQ101[0] == 20) ? _c('span', [_vm._v("C5~C6")]) : _vm._e(), _vm._v(" "), (scope.row.AQ101[0] == 21) ? _c('span', [_vm._v("C6~C7")]) : _vm._e(), _vm._v(" "), (scope.row.AQ101[0] == 22) ? _c('span', [_vm._v("C7~C8")]) : _vm._e()])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "胸椎段",
      "width": "100",
      "prop": "AQ1",
      "filters": _vm.AQ12Filt,
      "column-key": "AQ12"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-popover', {
          attrs: {
            "trigger": "hover",
            "placement": "top"
          }
        }, [_c('p', _vm._l((scope.row.AQ102), function(item) {
          return _c('span', [(item == 33) ? _c('span', [_vm._v("T1~T2")]) : _vm._e(), _vm._v(" "), (item == 34) ? _c('span', [_vm._v("T2~T3")]) : _vm._e(), _vm._v(" "), (item == 35) ? _c('span', [_vm._v("T3~T4")]) : _vm._e(), _vm._v(" "), (item == 36) ? _c('span', [_vm._v("T4~T5")]) : _vm._e(), _vm._v(" "), (item == 37) ? _c('span', [_vm._v("T5~T6")]) : _vm._e(), _vm._v(" "), (item == 38) ? _c('span', [_vm._v("T6~T7")]) : _vm._e(), _vm._v(" "), (item == 39) ? _c('span', [_vm._v("T7~T8")]) : _vm._e(), _vm._v(" "), (item == 40) ? _c('span', [_vm._v("T8~T9")]) : _vm._e(), _vm._v(" "), (item == 41) ? _c('span', [_vm._v("T9~T10")]) : _vm._e(), _vm._v(" "), (item == 42) ? _c('span', [_vm._v("T10~T11")]) : _vm._e(), _vm._v(" "), (item == 43) ? _c('span', [_vm._v("T11~T12")]) : _vm._e()])
        })), _vm._v(" "), _c('div', {
          staticClass: "name-wrapper",
          attrs: {
            "slot": "reference"
          },
          slot: "reference"
        }, [(scope.row.AQ102[0] == 33) ? _c('span', [_vm._v("T1~T2")]) : _vm._e(), _vm._v(" "), (scope.row.AQ102[0] == 34) ? _c('span', [_vm._v("T2~T3")]) : _vm._e(), _vm._v(" "), (scope.row.AQ102[0] == 35) ? _c('span', [_vm._v("T3~T4")]) : _vm._e(), _vm._v(" "), (scope.row.AQ102[0] == 36) ? _c('span', [_vm._v("T4~T5")]) : _vm._e(), _vm._v(" "), (scope.row.AQ102[0] == 37) ? _c('span', [_vm._v("T5~T6")]) : _vm._e(), _vm._v(" "), (scope.row.AQ102[0] == 38) ? _c('span', [_vm._v("T6~T7")]) : _vm._e(), _vm._v(" "), (scope.row.AQ102[0] == 39) ? _c('span', [_vm._v("T7~T8")]) : _vm._e(), _vm._v(" "), (scope.row.AQ102[0] == 40) ? _c('span', [_vm._v("T8~T9")]) : _vm._e(), _vm._v(" "), (scope.row.AQ102[0] == 41) ? _c('span', [_vm._v("T9~T10")]) : _vm._e(), _vm._v(" "), (scope.row.AQ102[0] == 42) ? _c('span', [_vm._v("T10~T11")]) : _vm._e(), _vm._v(" "), (scope.row.AQ102[0] == 43) ? _c('span', [_vm._v("T11~T12")]) : _vm._e()])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "腰椎段",
      "width": "100",
      "prop": "AQ1",
      "filters": _vm.AQ13Filt,
      "column-key": "AQ13"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-popover', {
          attrs: {
            "trigger": "hover",
            "placement": "top"
          }
        }, [_c('p', _vm._l((scope.row.AQ103), function(item) {
          return _c('span', [(item == 49) ? _c('span', [_vm._v("L1~L2")]) : _vm._e(), _vm._v(" "), (item == 50) ? _c('span', [_vm._v("L2~L3")]) : _vm._e(), _vm._v(" "), (item == 51) ? _c('span', [_vm._v("L3~L4")]) : _vm._e(), _vm._v(" "), (item == 52) ? _c('span', [_vm._v("L4~L5")]) : _vm._e()])
        })), _vm._v(" "), _c('div', {
          staticClass: "name-wrapper",
          attrs: {
            "slot": "reference"
          },
          slot: "reference"
        }, [(scope.row.AQ103[0] == 49) ? _c('span', [_vm._v("L1~L2")]) : _vm._e(), _vm._v(" "), (scope.row.AQ103[0] == 50) ? _c('span', [_vm._v("L2~L3")]) : _vm._e(), _vm._v(" "), (scope.row.AQ103[0] == 51) ? _c('span', [_vm._v("L3~L4")]) : _vm._e(), _vm._v(" "), (scope.row.AQ103[0] == 52) ? _c('span', [_vm._v("L4~L5")]) : _vm._e()])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "骶椎段",
      "width": "100",
      "prop": "AQ1",
      "filters": _vm.AQ14Filt,
      "column-key": "AQ14"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-popover', {
          attrs: {
            "trigger": "hover",
            "placement": "top"
          }
        }, [_c('p', _vm._l((scope.row.AQ104), function(item) {
          return _c('span', [(item == 65) ? _c('span', [_vm._v("S1~S2")]) : _vm._e(), _vm._v(" "), (item == 66) ? _c('span', [_vm._v("S2~S3")]) : _vm._e(), _vm._v(" "), (item == 67) ? _c('span', [_vm._v("S3~S4")]) : _vm._e(), _vm._v(" "), (item == 68) ? _c('span', [_vm._v("S4~S5")]) : _vm._e()])
        })), _vm._v(" "), _c('div', {
          staticClass: "name-wrapper",
          attrs: {
            "slot": "reference"
          },
          slot: "reference"
        }, [(scope.row.AQ104[0] == 65) ? _c('span', [_vm._v("S1~S2")]) : _vm._e(), _vm._v(" "), (scope.row.AQ104[0] == 66) ? _c('span', [_vm._v("S2~S3")]) : _vm._e(), _vm._v(" "), (scope.row.AQ104[0] == 67) ? _c('span', [_vm._v("S3~S4")]) : _vm._e(), _vm._v(" "), (scope.row.AQ104[0] == 68) ? _c('span', [_vm._v("S4~S5")]) : _vm._e()])])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "其他病种",
      "width": "150",
      "prop": "AQ2",
      "filters": _vm.AQ2Filt,
      "column-key": "AQ2"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.AQ2) ? _c('span', [_c('el-popover', {
          attrs: {
            "trigger": "hover",
            "placement": "top"
          }
        }, [_c('p', _vm._l((scope.row.AQ2), function(item) {
          return _c('span', [(item == 1) ? _c('span', [_vm._v("脑卒中")]) : _vm._e(), _vm._v(" "), (item == 2) ? _c('span', [_vm._v("脑瘫")]) : _vm._e(), _vm._v(" "), (item == 3) ? _c('span', [_vm._v("原发性脊髓炎")]) : _vm._e(), _vm._v(" "), (item == 4) ? _c('span', [_vm._v("小儿麻痹")]) : _vm._e(), _vm._v(" "), (item == 5) ? _c('span', [_vm._v("创伤性脑损伤")]) : _vm._e(), _vm._v(" "), (item == 6) ? _c('span', [_vm._v("骨关节炎")]) : _vm._e(), _vm._v(" "), (item == 7) ? _c('span', [_vm._v("进行性肌营养不良")]) : _vm._e(), _vm._v(" "), (item == 8) ? _c('span', [_vm._v("帕金森综合症")]) : _vm._e(), _vm._v(" "), (item == 9) ? _c('span', [_vm._v("阿尔茨海默病(老年痴呆)")]) : _vm._e(), _vm._v(" "), (typeof item == 'string') ? _c('span', [_vm._v(_vm._s(item))]) : _vm._e()])
        })), _vm._v(" "), _c('div', {
          staticClass: "name-wrapper",
          attrs: {
            "slot": "reference"
          },
          slot: "reference"
        }, [(scope.row.AQ2[0] == 1) ? _c('span', [_vm._v("脑卒中")]) : _vm._e(), _vm._v(" "), (scope.row.AQ2[0] == 2) ? _c('span', [_vm._v("脑瘫")]) : _vm._e(), _vm._v(" "), (scope.row.AQ2[0] == 3) ? _c('span', [_vm._v("原发性脊髓炎")]) : _vm._e(), _vm._v(" "), (scope.row.AQ2[0] == 4) ? _c('span', [_vm._v("小儿麻痹")]) : _vm._e(), _vm._v(" "), (scope.row.AQ2[0] == 5) ? _c('span', [_vm._v("创伤性脑损伤")]) : _vm._e(), _vm._v(" "), (scope.row.AQ2[0] == 6) ? _c('span', [_vm._v("骨关节炎")]) : _vm._e(), _vm._v(" "), (scope.row.AQ2[0] == 7) ? _c('span', [_vm._v("进行性肌营养不良")]) : _vm._e(), _vm._v(" "), (scope.row.AQ2[0] == 8) ? _c('span', [_vm._v("帕金森综合症")]) : _vm._e(), _vm._v(" "), (scope.row.AQ2[0] == 9) ? _c('span', [_vm._v("阿尔茨海默病(老年痴呆)")]) : _vm._e(), _vm._v(" "), (typeof scope.row.AQ2[0] == 'string') ? _c('span', [_vm._v(_vm._s(scope.row.AQ2[0]))]) : _vm._e()])])], 1) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "适用判断"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "近期是否站立训练",
      "width": "90",
      "prop": "AQ3",
      "filters": _vm.AQ31Filt,
      "column-key": "AQ31"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.AQ3[0] == 18) ? _c('span', [_vm._v("每天")]) : _vm._e(), _vm._v(" "), (scope.row.AQ3[0] == 19) ? _c('span', [_vm._v("偶尔")]) : _vm._e(), _vm._v(" "), (scope.row.AQ3[0] == 17) ? _c('span', [_vm._v("无")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "骨密度",
      "width": "80",
      "prop": "AQ3",
      "filters": _vm.AQ32Filt,
      "column-key": "AQ32"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.AQ3[1] == 34) ? _c('span', [_vm._v("T≤1")]) : _vm._e(), _vm._v(" "), (scope.row.AQ3[1] == 35) ? _c('span', [_vm._v("1≤T≤2.5")]) : _vm._e(), _vm._v(" "), (scope.row.AQ3[1] == 36) ? _c('span', [_vm._v("T>2.5")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "痉挛等级",
      "width": "90",
      "prop": "AQ3",
      "filters": _vm.AQ33Filt,
      "column-key": "AQ33"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.AQ3[2] == 50) ? _c('span', [_vm._v("0级")]) : _vm._e(), _vm._v(" "), (scope.row.AQ3[2] == 51) ? _c('span', [_vm._v("1级")]) : _vm._e(), _vm._v(" "), (scope.row.AQ3[2] == 52) ? _c('span', [_vm._v("2级")]) : _vm._e(), _vm._v(" "), (scope.row.AQ3[2] == 53) ? _c('span', [_vm._v("3级")]) : _vm._e(), _vm._v(" "), (scope.row.AQ3[2] == 54) ? _c('span', [_vm._v("4级")]) : _vm._e(), _vm._v(" "), (scope.row.AQ3[2] == 55) ? _c('span', [_vm._v("5级")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "上肢及手功能等级",
      "width": "90",
      "prop": "AQ3",
      "filters": _vm.AQ34Filt,
      "column-key": "AQ34"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.AQ3[3] == 66) ? _c('span', [_vm._v("1级")]) : _vm._e(), _vm._v(" "), (scope.row.AQ3[3] == 67) ? _c('span', [_vm._v("2级")]) : _vm._e(), _vm._v(" "), (scope.row.AQ3[3] == 68) ? _c('span', [_vm._v("3级")]) : _vm._e(), _vm._v(" "), (scope.row.AQ3[3] == 69) ? _c('span', [_vm._v("4级")]) : _vm._e(), _vm._v(" "), (scope.row.AQ3[3] == 70) ? _c('span', [_vm._v("5级")]) : _vm._e(), _vm._v(" "), (scope.row.AQ3[3] == 71) ? _c('span', [_vm._v("6级")]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "禁忌情况"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "体位性低血压",
      "width": "80",
      "prop": "AQ4",
      "filters": _vm.AQ41Filt,
      "column-key": "AQ41"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.AQ4[0] == 16) ? _c('span', [_vm._v("否")]) : _vm._e(), _vm._v(" "), (scope.row.AQ4[0] == 17) ? _c('span', [_vm._v("是")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "脊柱侧弯",
      "width": "65",
      "prop": "AQ4",
      "filters": _vm.AQ42Filt,
      "column-key": "AQ42"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.AQ4[1] == 32) ? _c('span', [_vm._v("否")]) : _vm._e(), _vm._v(" "), (scope.row.AQ4[1] == 33) ? _c('span', [_vm._v("是")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "关节严重变形",
      "width": "80",
      "prop": "AQ4",
      "filters": _vm.AQ43Filt,
      "column-key": "AQ43"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.AQ4[2] == 48) ? _c('span', [_vm._v("否")]) : _vm._e(), _vm._v(" "), (scope.row.AQ4[2] == 49) ? _c('span', [_vm._v("是")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "长短腿",
      "width": "78",
      "prop": "AQ4",
      "filters": _vm.AQ44Filt,
      "column-key": "AQ44"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.AQ4[3] == 64) ? _c('span', [_vm._v("否")]) : _vm._e(), _vm._v(" "), (scope.row.AQ4[3] == 65) ? _c('span', [_vm._v("是")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "认知障碍",
      "width": "70",
      "prop": "AQ4",
      "filters": _vm.AQ45Filt,
      "column-key": "AQ45"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.AQ4[4] == 80) ? _c('span', [_vm._v("否")]) : _vm._e(), _vm._v(" "), (scope.row.AQ4[4] == 81) ? _c('span', [_vm._v("是")]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "受伤原因",
      "width": "90",
      "prop": "BQ1",
      "filters": _vm.BQ1Filt,
      "column-key": "BQ1"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.BQ1) ? _c('span', [(scope.row.BQ1 === 2) ? _c('span', [_vm._v("原发性")]) : _vm._e(), _vm._v(" "), (scope.row.BQ1 === 3) ? _c('span', [_vm._v("病毒感染")]) : _vm._e(), _vm._v(" "), (scope.row.BQ1 === 4) ? _c('span', [_vm._v("病变")]) : _vm._e(), _vm._v(" "), (scope.row.BQ1 === 5) ? _c('span', [_vm._v("意外事故")]) : _vm._e(), _vm._v(" "), (typeof scope.row.BQ1 == 'string') ? _c('span', [_vm._v(_vm._s(scope.row.BQ1))]) : _vm._e()]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "政策福利",
      "width": "160",
      "prop": "BQ2",
      "filters": _vm.BQ2Filt,
      "column-key": "BQ2"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.BQ2) ? _c('span', _vm._l((scope.row.BQ2), function(item) {
          return _c('span', [(item == 2) ? _c('span', [_vm._v("残联")]) : _vm._e(), _vm._v(" "), (item == 3) ? _c('span', [_vm._v("医保")]) : _vm._e(), _vm._v(" "), (item == 4) ? _c('span', [_vm._v("工伤")]) : _vm._e(), _vm._v(" "), (item == 5) ? _c('span', [_vm._v("自费")]) : _vm._e(), _vm._v(" "), (typeof item == 'string') ? _c('span', [_vm._v("其他:" + _vm._s(item))]) : _vm._e()])
        })) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "政府补贴额度",
      "width": "120",
      "prop": "BQ3",
      "filters": _vm.BQ3Filt,
      "column-key": "BQ3"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.BQ3) ? _c('span', [(scope.row.BQ3 == 1) ? _c('span', [_vm._v("无")]) : _vm._e(), _vm._v(" "), (scope.row.BQ3 == 2) ? _c('span', [_vm._v("0-3千")]) : _vm._e(), _vm._v(" "), (scope.row.BQ3 == 3) ? _c('span', [_vm._v("3-6千")]) : _vm._e(), _vm._v(" "), (scope.row.BQ3 == 4) ? _c('span', [_vm._v("6-9千")]) : _vm._e(), _vm._v(" "), (scope.row.BQ3 == 5) ? _c('span', [_vm._v("9千-1.5万")]) : _vm._e(), _vm._v(" "), (scope.row.BQ3 == 6) ? _c('span', [_vm._v("1.5-2万")]) : _vm._e(), _vm._v(" "), (scope.row.BQ3 == 7) ? _c('span', [_vm._v("2-3万")]) : _vm._e(), _vm._v(" "), (scope.row.BQ3 == 8) ? _c('span', [_vm._v("3万以上")]) : _vm._e(), _vm._v(" "), (scope.row.BQ3 == 9) ? _c('span', [_vm._v("全额")]) : _vm._e()]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "目前使用的轮椅"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "类型",
      "width": "135",
      "prop": "BQ4",
      "filters": _vm.BQ4Filt,
      "column-key": "BQ4"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.BQ4) ? _c('span', [(scope.row.BQ4 == 2) ? _c('span', [_vm._v("手动轮椅")]) : _vm._e(), _vm._v(" "), (scope.row.BQ4 == 3) ? _c('span', [_vm._v("电动轮椅")]) : _vm._e(), _vm._v(" "), (scope.row.BQ4 == 4) ? _c('span', [_vm._v("手动和电动轮椅")]) : _vm._e(), _vm._v(" "), (typeof scope.row.BQ4 == 'string') ? _c('span', [_vm._v("其他：" + _vm._s(scope.row.BQ4))]) : _vm._e()]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "品牌",
      "width": "120",
      "prop": "BQ5",
      "filters": _vm.BQ5Filt,
      "column-key": "BQ5"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.BQ5) ? _c('span', [_c('el-popover', {
          attrs: {
            "trigger": "hover",
            "placement": "top"
          }
        }, [_c('p', _vm._l((scope.row.BQ5), function(item) {
          return _c('span', [(item == 2) ? _c('span', [_vm._v("奥托博克")]) : _vm._e(), _vm._v(" "), (item == 3) ? _c('span', [_vm._v("英维康")]) : _vm._e(), _vm._v(" "), (item == 4) ? _c('span', [_vm._v("鱼跃")]) : _vm._e(), _vm._v(" "), (item == 5) ? _c('span', [_vm._v("凯洋")]) : _vm._e(), _vm._v(" "), (item == 6) ? _c('span', [_vm._v("卫美恒")]) : _vm._e(), _vm._v(" "), (item == 7) ? _c('span', [_vm._v("巴森巴乔")]) : _vm._e(), _vm._v(" "), (item == 8) ? _c('span', [_vm._v("威之群")]) : _vm._e(), _vm._v(" "), (item == 9) ? _c('span', [_vm._v("康扬")]) : _vm._e(), _vm._v(" "), (item == 10) ? _c('span', [_vm._v("互邦")]) : _vm._e(), _vm._v(" "), (item == 11) ? _c('span', [_vm._v("Ti")]) : _vm._e(), _vm._v(" "), (item == 12) ? _c('span', [_vm._v("松永")]) : _vm._e(), _vm._v(" "), (item == 13) ? _c('span', [_vm._v("搏动")]) : _vm._e(), _vm._v(" "), (typeof item == 'string') ? _c('span', [_vm._v("其他:" + _vm._s(item))]) : _vm._e()])
        })), _vm._v(" "), _c('div', {
          staticClass: "name-wrapper",
          attrs: {
            "slot": "reference"
          },
          slot: "reference"
        }, [(scope.row.BQ5[0] == 2) ? _c('span', [_vm._v("奥托博克")]) : _vm._e(), _vm._v(" "), (scope.row.BQ5[0] == 3) ? _c('span', [_vm._v("英维康")]) : _vm._e(), _vm._v(" "), (scope.row.BQ5[0] == 4) ? _c('span', [_vm._v("鱼跃")]) : _vm._e(), _vm._v(" "), (scope.row.BQ5[0] == 5) ? _c('span', [_vm._v("凯洋")]) : _vm._e(), _vm._v(" "), (scope.row.BQ5[0] == 6) ? _c('span', [_vm._v("卫美恒")]) : _vm._e(), _vm._v(" "), (scope.row.BQ5[0] == 7) ? _c('span', [_vm._v("巴森巴乔")]) : _vm._e(), _vm._v(" "), (scope.row.BQ5[0] == 8) ? _c('span', [_vm._v("威之群")]) : _vm._e(), _vm._v(" "), (scope.row.BQ5[0] == 9) ? _c('span', [_vm._v("康扬")]) : _vm._e(), _vm._v(" "), (scope.row.BQ5[0] == 10) ? _c('span', [_vm._v("互邦")]) : _vm._e(), _vm._v(" "), (scope.row.BQ5[0] == 11) ? _c('span', [_vm._v("Ti")]) : _vm._e(), _vm._v(" "), (scope.row.BQ5[0] == 12) ? _c('span', [_vm._v("松永")]) : _vm._e(), _vm._v(" "), (scope.row.BQ5[0] == 13) ? _c('span', [_vm._v("搏动")]) : _vm._e(), _vm._v(" "), (typeof scope.row.BQ5[0] == 'string') ? _c('span', [_vm._v("其他:" + _vm._s(scope.row.BQ5[0]))]) : _vm._e()])])], 1) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "价格",
      "width": "90",
      "prop": "BQ6",
      "filters": _vm.BQ6Filt,
      "column-key": "BQ6"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.BQ6) ? _c('span', [(scope.row.BQ6 == 2) ? _c('span', [_vm._v("5千以下")]) : _vm._e(), _vm._v(" "), (scope.row.BQ6 == 3) ? _c('span', [_vm._v("5千-1万")]) : _vm._e(), _vm._v(" "), (scope.row.BQ6 == 4) ? _c('span', [_vm._v("1-2万")]) : _vm._e(), _vm._v(" "), (scope.row.BQ6 == 5) ? _c('span', [_vm._v("2-3万")]) : _vm._e(), _vm._v(" "), (scope.row.BQ6 == 6) ? _c('span', [_vm._v("3-4万")]) : _vm._e(), _vm._v(" "), (scope.row.BQ6 == 7) ? _c('span', [_vm._v("4万以上")]) : _vm._e()]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "医院康复训练费用",
      "width": "90",
      "prop": "BQ8",
      "filters": _vm.BQ8Filt,
      "column-key": "BQ8"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(!scope.row.BQ8) ? _c('span') : _vm._e(), _vm._v(" "), (scope.row.BQ8 == 2) ? _c('span', [_vm._v("5千以下")]) : _vm._e(), _vm._v(" "), (scope.row.BQ8 == 3) ? _c('span', [_vm._v("5千-1万")]) : _vm._e(), _vm._v(" "), (scope.row.BQ8 == 4) ? _c('span', [_vm._v("1-2万")]) : _vm._e(), _vm._v(" "), (scope.row.BQ8 == 5) ? _c('span', [_vm._v("2-3万")]) : _vm._e(), _vm._v(" "), (scope.row.BQ8 == 6) ? _c('span', [_vm._v("3-4万")]) : _vm._e(), _vm._v(" "), (scope.row.BQ8 == 7) ? _c('span', [_vm._v("4万以上")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "现有康复器材"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "站立架",
      "width": "100",
      "prop": "BQ9",
      "filters": _vm.BQ91Filt,
      "column-key": "BQ91"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.BQ9) ? _c('span', _vm._l((scope.row.BQ9), function(item) {
          return _c('span', [(item == 18) ? _c('span', [_vm._v("200-400元")]) : _vm._e(), _vm._v(" "), (item == 19) ? _c('span', [_vm._v("400-600元")]) : _vm._e(), _vm._v(" "), (item == 20) ? _c('span', [_vm._v("600-800元")]) : _vm._e(), _vm._v(" "), (item == 21) ? _c('span', [_vm._v("800元以上")]) : _vm._e()])
        })) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "站立床",
      "width": "100",
      "prop": "BQ9",
      "filters": _vm.BQ92Filt,
      "column-key": "BQ92"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.BQ9) ? _c('span', _vm._l((scope.row.BQ9), function(item) {
          return _c('span', [(item == 34) ? _c('span', [_vm._v("500-1000元")]) : _vm._e(), _vm._v(" "), (item == 35) ? _c('span', [_vm._v("1000-1500元")]) : _vm._e(), _vm._v(" "), (item == 36) ? _c('span', [_vm._v("1500-2000元")]) : _vm._e(), _vm._v(" "), (item == 37) ? _c('span', [_vm._v("2000元以上")]) : _vm._e()])
        })) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "站立柜",
      "width": "100",
      "prop": "BQ9",
      "filters": _vm.BQ93Filt,
      "column-key": "BQ93"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.BQ9) ? _c('span', _vm._l((scope.row.BQ9), function(item) {
          return _c('span', [(item == 50) ? _c('span', [_vm._v("200-400元")]) : _vm._e(), _vm._v(" "), (item == 51) ? _c('span', [_vm._v("400-600元")]) : _vm._e(), _vm._v(" "), (item == 52) ? _c('span', [_vm._v("600-800元")]) : _vm._e(), _vm._v(" "), (item == 53) ? _c('span', [_vm._v("800元以上")]) : _vm._e()])
        })) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "踝支具",
      "width": "100",
      "prop": "BQ9",
      "filters": _vm.BQ94Filt,
      "column-key": "BQ94"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.BQ9) ? _c('span', _vm._l((scope.row.BQ9), function(item) {
          return _c('span', [(item == 66) ? _c('span', [_vm._v("40-100元")]) : _vm._e(), _vm._v(" "), (item == 67) ? _c('span', [_vm._v("100-300元")]) : _vm._e(), _vm._v(" "), (item == 68) ? _c('span', [_vm._v("300-700元")]) : _vm._e(), _vm._v(" "), (item == 69) ? _c('span', [_vm._v("700元以上")]) : _vm._e()])
        })) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "行走支具",
      "width": "100",
      "prop": "BQ9",
      "filters": _vm.BQ95Filt,
      "column-key": "BQ95"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.BQ9) ? _c('span', _vm._l((scope.row.BQ9), function(item) {
          return _c('span', [(item == 82) ? _c('span', [_vm._v("500-1000元")]) : _vm._e(), _vm._v(" "), (item == 83) ? _c('span', [_vm._v("1000-1500元")]) : _vm._e(), _vm._v(" "), (item == 84) ? _c('span', [_vm._v("1500-2000元")]) : _vm._e(), _vm._v(" "), (item == 85) ? _c('span', [_vm._v("2000元以上")]) : _vm._e()])
        })) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "气动理疗仪",
      "width": "105",
      "prop": "BQ9",
      "filters": _vm.BQ96Filt,
      "column-key": "BQ96"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.BQ9) ? _c('span', _vm._l((scope.row.BQ9), function(item) {
          return _c('span', [(item == 98) ? _c('span', [_vm._v("100-300元")]) : _vm._e(), _vm._v(" "), (item == 99) ? _c('span', [_vm._v("300-600元")]) : _vm._e(), _vm._v(" "), (item == 100) ? _c('span', [_vm._v("600-1200元")]) : _vm._e(), _vm._v(" "), (item == 101) ? _c('span', [_vm._v("1200元以上")]) : _vm._e()])
        })) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "磁疗仪",
      "width": "100",
      "prop": "BQ9",
      "filters": _vm.BQ97Filt,
      "column-key": "BQ97"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.BQ9) ? _c('span', _vm._l((scope.row.BQ9), function(item) {
          return _c('span', [(item == 114) ? _c('span', [_vm._v("50-200元")]) : _vm._e(), _vm._v(" "), (item == 115) ? _c('span', [_vm._v("200-400元")]) : _vm._e(), _vm._v(" "), (item == 116) ? _c('span', [_vm._v("400-800元")]) : _vm._e(), _vm._v(" "), (item == 117) ? _c('span', [_vm._v("800元以上")]) : _vm._e()])
        })) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "家中康复训练需求",
      "width": "150",
      "prop": "BQ10",
      "filters": _vm.BQ10Filt,
      "column-key": "BQ10"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.BQ10) ? _c('span', [_c('el-popover', {
          attrs: {
            "trigger": "hover",
            "placement": "top"
          }
        }, [_c('p', _vm._l((scope.row.BQ10), function(item) {
          return _c('span', [(item == 2) ? _c('span', [_vm._v("站立训练")]) : _vm._e(), _vm._v(" "), (item == 3) ? _c('span', [_vm._v("行走训练")]) : _vm._e(), _vm._v(" "), (item == 4) ? _c('span', [_vm._v("蹲起训练")]) : _vm._e(), _vm._v(" "), (item == 5) ? _c('span', [_vm._v("跟腱拉伸训练")]) : _vm._e(), _vm._v(" "), (typeof item == 'string') ? _c('span', [_vm._v("其他:" + _vm._s(item))]) : _vm._e()])
        })), _vm._v(" "), _c('div', {
          staticClass: "name-wrapper",
          attrs: {
            "slot": "reference"
          },
          slot: "reference"
        }, [(scope.row.BQ10[0] == 2) ? _c('span', [_vm._v("站立训练")]) : _vm._e(), _vm._v(" "), (scope.row.BQ10[0] == 3) ? _c('span', [_vm._v("行走训练")]) : _vm._e(), _vm._v(" "), (scope.row.BQ10[0] == 4) ? _c('span', [_vm._v("蹲起训练")]) : _vm._e(), _vm._v(" "), (scope.row.BQ10[0] == 5) ? _c('span', [_vm._v("跟腱拉伸训练")]) : _vm._e(), _vm._v(" "), (typeof scope.row.BQ10[0] == 'string') ? _c('span', [_vm._v("其他:" + _vm._s(scope.row.BQ10[0]))]) : _vm._e()])])], 1) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "家务活动完成情况",
      "width": "150",
      "prop": "BQ11",
      "filters": _vm.BQ11Filt,
      "column-key": "BQ11"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.BQ11) ? _c('span', [_c('el-popover', {
          attrs: {
            "trigger": "hover",
            "placement": "top"
          }
        }, [_c('p', _vm._l((scope.row.BQ11), function(item) {
          return _c('span', [(item == 2) ? _c('span', [_vm._v("做饭")]) : _vm._e(), _vm._v(" "), (item == 3) ? _c('span', [_vm._v("洗衣")]) : _vm._e(), _vm._v(" "), (item == 4) ? _c('span', [_vm._v("打扫卫生")]) : _vm._e(), _vm._v(" "), (item == 5) ? _c('span', [_vm._v("高低取物")]) : _vm._e(), _vm._v(" "), (item == 6) ? _c('span', [_vm._v("床-轮椅转移")]) : _vm._e(), _vm._v(" "), (item == 7) ? _c('span', [_vm._v("轮椅-马桶转移")]) : _vm._e(), _vm._v(" "), (item == 8) ? _c('span', [_vm._v("康复训练")]) : _vm._e(), _vm._v(" "), (typeof item == 'string') ? _c('span', [_vm._v("其他:" + _vm._s(item))]) : _vm._e()])
        })), _vm._v(" "), _c('div', {
          staticClass: "name-wrapper",
          attrs: {
            "slot": "reference"
          },
          slot: "reference"
        }, [(scope.row.BQ11[0] == 2) ? _c('span', [_vm._v("做饭")]) : _vm._e(), _vm._v(" "), (scope.row.BQ11[0] == 3) ? _c('span', [_vm._v("洗衣")]) : _vm._e(), _vm._v(" "), (scope.row.BQ11[0] == 4) ? _c('span', [_vm._v("打扫卫生")]) : _vm._e(), _vm._v(" "), (scope.row.BQ11[0] == 5) ? _c('span', [_vm._v("高低取物")]) : _vm._e(), _vm._v(" "), (scope.row.BQ11[0] == 6) ? _c('span', [_vm._v("床-轮椅转移")]) : _vm._e(), _vm._v(" "), (scope.row.BQ11[0] == 7) ? _c('span', [_vm._v("轮椅-马桶转移")]) : _vm._e(), _vm._v(" "), (scope.row.BQ11[0] == 8) ? _c('span', [_vm._v("康复训练")]) : _vm._e(), _vm._v(" "), (typeof scope.row.BQ11[0] == 'string') ? _c('span', [_vm._v("其他:" + _vm._s(scope.row.BQ11[0]))]) : _vm._e()])])], 1) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "短距离出行工具",
      "width": "140",
      "prop": "BQ12",
      "filters": _vm.BQ12Filt,
      "column-key": "BQ12"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.BQ12) ? _c('span', [_c('el-popover', {
          attrs: {
            "trigger": "hover",
            "placement": "top"
          }
        }, [_c('p', _vm._l((scope.row.BQ12), function(item) {
          return _c('span', [(item == 2) ? _c('span', [_vm._v("电动轮椅")]) : _vm._e(), _vm._v(" "), (item == 3) ? _c('span', [_vm._v("手动轮椅")]) : _vm._e(), _vm._v(" "), (item == 4) ? _c('span', [_vm._v("代步车")]) : _vm._e(), _vm._v(" "), (item == 5) ? _c('span', [_vm._v("汽车")]) : _vm._e(), _vm._v(" "), (typeof item == 'string') ? _c('span', [_vm._v("其他:" + _vm._s(item))]) : _vm._e()])
        })), _vm._v(" "), _c('div', {
          staticClass: "name-wrapper",
          attrs: {
            "slot": "reference"
          },
          slot: "reference"
        }, [(scope.row.BQ12[0] == 2) ? _c('span', [_vm._v("电动轮椅")]) : _vm._e(), _vm._v(" "), (scope.row.BQ12[0] == 3) ? _c('span', [_vm._v("手动轮椅")]) : _vm._e(), _vm._v(" "), (scope.row.BQ12[0] == 4) ? _c('span', [_vm._v("代步车")]) : _vm._e(), _vm._v(" "), (scope.row.BQ12[0] == 5) ? _c('span', [_vm._v("汽车")]) : _vm._e(), _vm._v(" "), (typeof scope.row.BQ12[0] == 'string') ? _c('span', [_vm._v("其他:" + _vm._s(scope.row.BQ12[0]))]) : _vm._e()])])], 1) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "远距离出行工具",
      "width": "140",
      "prop": "BQ13",
      "filters": _vm.BQ13Filt,
      "column-key": "BQ13"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.BQ13) ? _c('span', [_c('el-popover', {
          attrs: {
            "trigger": "hover",
            "placement": "top"
          }
        }, [_c('p', _vm._l((scope.row.BQ13), function(item) {
          return _c('span', [(item == 2) ? _c('span', [_vm._v("电动轮椅")]) : _vm._e(), _vm._v(" "), (item == 3) ? _c('span', [_vm._v("手动轮椅")]) : _vm._e(), _vm._v(" "), (item == 4) ? _c('span', [_vm._v("代步车")]) : _vm._e(), _vm._v(" "), (item == 5) ? _c('span', [_vm._v("汽车")]) : _vm._e(), _vm._v(" "), (typeof item == 'string') ? _c('span', [_vm._v("其他:" + _vm._s(item))]) : _vm._e()])
        })), _vm._v(" "), _c('div', {
          staticClass: "name-wrapper",
          attrs: {
            "slot": "reference"
          },
          slot: "reference"
        }, [(scope.row.BQ13[0] == 2) ? _c('span', [_vm._v("电动轮椅")]) : _vm._e(), _vm._v(" "), (scope.row.BQ13[0] == 3) ? _c('span', [_vm._v("手动轮椅")]) : _vm._e(), _vm._v(" "), (scope.row.BQ13[0] == 4) ? _c('span', [_vm._v("代步车")]) : _vm._e(), _vm._v(" "), (scope.row.BQ13[0] == 5) ? _c('span', [_vm._v("汽车")]) : _vm._e(), _vm._v(" "), (typeof scope.row.BQ13[0] == 'string') ? _c('span', [_vm._v("其他:" + _vm._s(scope.row.BQ12[0]))]) : _vm._e()])])], 1) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "爱好",
      "width": "100",
      "prop": "BQ14",
      "filters": _vm.BQ14Filt,
      "column-key": "BQ14"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.BQ14) ? _c('span', [_c('el-popover', {
          attrs: {
            "trigger": "hover",
            "placement": "top"
          }
        }, [_c('p', _vm._l((scope.row.BQ14), function(item) {
          return _c('span', [(item == 2) ? _c('span', [_vm._v("手游(王者荣耀等)")]) : _vm._e(), _vm._v(" "), (item == 3) ? _c('span', [_vm._v("网游(LOL绝地求生等)")]) : _vm._e(), _vm._v(" "), (item == 4) ? _c('span', [_vm._v("看电视")]) : _vm._e(), _vm._v(" "), (item == 5) ? _c('span', [_vm._v("电影")]) : _vm._e(), _vm._v(" "), (item == 6) ? _c('span', [_vm._v("唱歌")]) : _vm._e(), _vm._v(" "), (item == 7) ? _c('span', [_vm._v("跳舞")]) : _vm._e(), _vm._v(" "), (item == 8) ? _c('span', [_vm._v("驾驶")]) : _vm._e(), _vm._v(" "), (item == 9) ? _c('span', [_vm._v("旅游")]) : _vm._e(), _vm._v(" "), (item == 10) ? _c('span', [_vm._v("读书")]) : _vm._e(), _vm._v(" "), (item == 11) ? _c('span', [_vm._v("烹饪")]) : _vm._e(), _vm._v(" "), (item == 12) ? _c('span', [_vm._v("绘画")]) : _vm._e(), _vm._v(" "), (typeof item == 'string') ? _c('span', [_vm._v("其他:" + _vm._s(item))]) : _vm._e()])
        })), _vm._v(" "), _c('div', {
          staticClass: "name-wrapper",
          attrs: {
            "slot": "reference"
          },
          slot: "reference"
        }, [(scope.row.BQ14[0] == 2) ? _c('span', [_vm._v("手游")]) : _vm._e(), _vm._v(" "), (scope.row.BQ14[0] == 3) ? _c('span', [_vm._v("网游")]) : _vm._e(), _vm._v(" "), (scope.row.BQ14[0] == 4) ? _c('span', [_vm._v("看电视")]) : _vm._e(), _vm._v(" "), (scope.row.BQ14[0] == 5) ? _c('span', [_vm._v("电影")]) : _vm._e(), _vm._v(" "), (scope.row.BQ14[0] == 6) ? _c('span', [_vm._v("唱歌")]) : _vm._e(), _vm._v(" "), (scope.row.BQ14[0] == 7) ? _c('span', [_vm._v("跳舞")]) : _vm._e(), _vm._v(" "), (scope.row.BQ14[0] == 8) ? _c('span', [_vm._v("驾驶")]) : _vm._e(), _vm._v(" "), (scope.row.BQ14[0] == 9) ? _c('span', [_vm._v("旅游")]) : _vm._e(), _vm._v(" "), (scope.row.BQ14[0] == 10) ? _c('span', [_vm._v("读书")]) : _vm._e(), _vm._v(" "), (scope.row.BQ14[0] == 11) ? _c('span', [_vm._v("烹饪")]) : _vm._e(), _vm._v(" "), (scope.row.BQ14[0] == 12) ? _c('span', [_vm._v("绘画")]) : _vm._e(), _vm._v(" "), (typeof scope.row.BQ14[0] == 'string') ? _c('span', [_vm._v("其他:" + _vm._s(scope.row.BQ14[0]))]) : _vm._e()])])], 1) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "康复新闻渠道",
      "width": "120",
      "prop": "BQ15",
      "filters": _vm.BQ15Filt,
      "column-key": "BQ15"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.BQ15) ? _c('span', [_c('el-popover', {
          attrs: {
            "trigger": "hover",
            "placement": "top"
          }
        }, [_c('p', _vm._l((scope.row.BQ15), function(item) {
          return _c('span', [(item == 2) ? _c('span', [_vm._v("微信")]) : _vm._e(), _vm._v(" "), (item == 3) ? _c('span', [_vm._v("公众号")]) : _vm._e(), _vm._v(" "), (item == 4) ? _c('span', [_vm._v("微博")]) : _vm._e(), _vm._v(" "), (item == 5) ? _c('span', [_vm._v("QQ")]) : _vm._e(), _vm._v(" "), (item == 6) ? _c('span', [_vm._v("论坛")]) : _vm._e(), _vm._v(" "), (item == 7) ? _c('span', [_vm._v("政府网站")]) : _vm._e(), _vm._v(" "), (item == 8) ? _c('span', [_vm._v("电台")]) : _vm._e(), _vm._v(" "), (item == 9) ? _c('span', [_vm._v("百度")]) : _vm._e(), _vm._v(" "), (item == 10) ? _c('span', [_vm._v("今日头条")]) : _vm._e(), _vm._v(" "), (item == 11) ? _c('span', [_vm._v("网易新闻")]) : _vm._e(), _vm._v(" "), (item == 12) ? _c('span', [_vm._v("腾讯新闻")]) : _vm._e(), _vm._v(" "), (typeof item == 'string') ? _c('span', [_vm._v("其他:" + _vm._s(item))]) : _vm._e()])
        })), _vm._v(" "), _c('div', {
          staticClass: "name-wrapper",
          attrs: {
            "slot": "reference"
          },
          slot: "reference"
        }, [(scope.row.BQ15[0] == 2) ? _c('span', [_vm._v("微信")]) : _vm._e(), _vm._v(" "), (scope.row.BQ15[0] == 3) ? _c('span', [_vm._v("公众号")]) : _vm._e(), _vm._v(" "), (scope.row.BQ15[0] == 4) ? _c('span', [_vm._v("微博")]) : _vm._e(), _vm._v(" "), (scope.row.BQ15[0] == 5) ? _c('span', [_vm._v("QQ")]) : _vm._e(), _vm._v(" "), (scope.row.BQ15[0] == 6) ? _c('span', [_vm._v("论坛")]) : _vm._e(), _vm._v(" "), (scope.row.BQ15[0] == 7) ? _c('span', [_vm._v("政府网站")]) : _vm._e(), _vm._v(" "), (scope.row.BQ15[0] == 8) ? _c('span', [_vm._v("电台")]) : _vm._e(), _vm._v(" "), (scope.row.BQ15[0] == 9) ? _c('span', [_vm._v("百度")]) : _vm._e(), _vm._v(" "), (scope.row.BQ15[0] == 10) ? _c('span', [_vm._v("今日头条")]) : _vm._e(), _vm._v(" "), (scope.row.BQ15[0] == 11) ? _c('span', [_vm._v("网易新闻")]) : _vm._e(), _vm._v(" "), (scope.row.BQ15[0] == 12) ? _c('span', [_vm._v("腾讯新闻")]) : _vm._e(), _vm._v(" "), (typeof scope.row.BQ15[0] == 'string') ? _c('span', [_vm._v("其他:" + _vm._s(scope.row.BQ15[0]))]) : _vm._e()])])], 1) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "如厕解决办法",
      "width": "120",
      "prop": "BQ16",
      "filters": _vm.BQ16Filt,
      "column-key": "BQ16"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.BQ16) ? _c('span', [_c('el-popover', {
          attrs: {
            "trigger": "hover",
            "placement": "top"
          }
        }, [_c('p', _vm._l((scope.row.BQ16), function(item) {
          return _c('span', [(item == 2) ? _c('span', [_vm._v("大小便护理器")]) : _vm._e(), _vm._v(" "), (item == 3) ? _c('span', [_vm._v("家人")]) : _vm._e(), _vm._v(" "), (item == 4) ? _c('span', [_vm._v("护工")]) : _vm._e(), _vm._v(" "), (item == 5) ? _c('span', [_vm._v("自己")]) : _vm._e()])
        })), _vm._v(" "), _c('div', {
          staticClass: "name-wrapper",
          attrs: {
            "slot": "reference"
          },
          slot: "reference"
        }, [(scope.row.BQ16[0] == 2) ? _c('span', [_vm._v("大小便护理器")]) : _vm._e(), _vm._v(" "), (scope.row.BQ16[0] == 3) ? _c('span', [_vm._v("家人")]) : _vm._e(), _vm._v(" "), (scope.row.BQ16[0] == 4) ? _c('span', [_vm._v("护工")]) : _vm._e(), _vm._v(" "), (scope.row.BQ16[0] == 5) ? _c('span', [_vm._v("自己")]) : _vm._e()])])], 1) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "护工雇佣情况",
      "width": "80",
      "prop": "BQ17",
      "filters": _vm.BQ17Filt,
      "column-key": "BQ17"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.BQ17) ? _c('span', [(scope.row.BQ17 == 1) ? _c('span', [_vm._v("无")]) : _vm._e(), _vm._v(" "), (scope.row.BQ17 == 2) ? _c('span', [_vm._v("以前有")]) : _vm._e(), _vm._v(" "), (scope.row.BQ17 == 3) ? _c('span', [_vm._v("正在雇佣")]) : _vm._e()]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "护工年费用",
      "width": "80",
      "prop": "BQ18",
      "filters": _vm.BQ18Filt,
      "column-key": "BQ18"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.BQ18) ? _c('span', [(scope.row.BQ18 == 1) ? _c('span', [_vm._v("无")]) : _vm._e(), _vm._v(" "), (scope.row.BQ18 == 2) ? _c('span', [_vm._v("4-5万")]) : _vm._e(), _vm._v(" "), (scope.row.BQ18 == 3) ? _c('span', [_vm._v("5-6万")]) : _vm._e(), _vm._v(" "), (scope.row.BQ18 == 4) ? _c('span', [_vm._v("6-7万")]) : _vm._e(), _vm._v(" "), (scope.row.BQ18 == 5) ? _c('span', [_vm._v("7-8万")]) : _vm._e(), _vm._v(" "), (scope.row.BQ18 == 6) ? _c('span', [_vm._v("10万以上")]) : _vm._e()]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "个人月收入",
      "width": "105",
      "prop": "BQ19",
      "filters": _vm.BQ19Filt,
      "column-key": "BQ19"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.BQ19) ? _c('span', [(scope.row.BQ19 == 1) ? _c('span', [_vm._v("无")]) : _vm._e(), _vm._v(" "), (scope.row.BQ19 == 2) ? _c('span', [_vm._v("4千以下")]) : _vm._e(), _vm._v(" "), (scope.row.BQ19 == 3) ? _c('span', [_vm._v("4-8千")]) : _vm._e(), _vm._v(" "), (scope.row.BQ19 == 4) ? _c('span', [_vm._v("8千-1.2万")]) : _vm._e(), _vm._v(" "), (scope.row.BQ19 == 5) ? _c('span', [_vm._v("1.2万以上")]) : _vm._e()]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "医疗设备年投入",
      "width": "80",
      "prop": "BQ20",
      "filters": _vm.BQ20Filt,
      "column-key": "BQ20"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.BQ20) ? _c('span', [(scope.row.BQ20 == 2) ? _c('span', [_vm._v("5千以下")]) : _vm._e(), _vm._v(" "), (scope.row.BQ20 == 3) ? _c('span', [_vm._v("5千-1万")]) : _vm._e(), _vm._v(" "), (scope.row.BQ20 == 4) ? _c('span', [_vm._v("1-2万")]) : _vm._e(), _vm._v(" "), (scope.row.BQ20 == 5) ? _c('span', [_vm._v("2-4万")]) : _vm._e(), _vm._v(" "), (scope.row.BQ20 == 6) ? _c('span', [_vm._v("4-8万")]) : _vm._e(), _vm._v(" "), (scope.row.BQ20 == 7) ? _c('span', [_vm._v("8万以上")]) : _vm._e()]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "家庭人口数",
      "width": "105",
      "prop": "BQ21",
      "filters": _vm.BQ21Filt,
      "column-key": "BQ21"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.BQ21) ? _c('span', [(scope.row.BQ21 == 2) ? _c('span', [_vm._v("2人及以下")]) : _vm._e(), _vm._v(" "), (scope.row.BQ21 == 3) ? _c('span', [_vm._v("3人")]) : _vm._e(), _vm._v(" "), (scope.row.BQ21 == 4) ? _c('span', [_vm._v("4人")]) : _vm._e(), _vm._v(" "), (scope.row.BQ21 == 5) ? _c('span', [_vm._v("4人以上")]) : _vm._e()]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "家庭年收入",
      "width": "105",
      "prop": "BQ22",
      "filters": _vm.BQ22Filt,
      "column-key": "BQ22"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.BQ22) ? _c('span', [(scope.row.BQ22 == 2) ? _c('span', [_vm._v("6万以下")]) : _vm._e(), _vm._v(" "), (scope.row.BQ22 == 3) ? _c('span', [_vm._v("6-12万")]) : _vm._e(), _vm._v(" "), (scope.row.BQ22 == 4) ? _c('span', [_vm._v("12-20万")]) : _vm._e(), _vm._v(" "), (scope.row.BQ22 == 5) ? _c('span', [_vm._v("20万以上")]) : _vm._e()]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "100",
      "label": "备注",
      "prop": "remark"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.remark) ? _c('span', [_c('el-popover', {
          attrs: {
            "trigger": "hover",
            "placement": "top"
          }
        }, [_c('p', [(scope.row.remark) ? _c('span', [_vm._v(_vm._s(scope.row.remark))]) : _vm._e(), _vm._v(" "), (!scope.row.remark) ? _c('span', [_vm._v("无")]) : _vm._e()]), _vm._v(" "), _c('div', {
          staticClass: "name-wrapper",
          attrs: {
            "slot": "reference"
          },
          slot: "reference"
        }, [(scope.row.remark) ? _c('span', [(scope.row.remark.length < 6) ? _c('span', [_vm._v(_vm._s(scope.row.remark))]) : _vm._e(), _vm._v(" "), (scope.row.remark.length >= 7) ? _c('span', [_vm._v("查看")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!scope.row.remark) ? _c('span', [_vm._v("无")]) : _vm._e()])])], 1) : _vm._e()]
      }
    }])
  }), _vm._v(" "), (_vm.Limits.questionnaire_delete) ? _c('el-table-column', {
    attrs: {
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "mini",
            "type": "danger",
            "icon": "el-icon-delete"
          },
          on: {
            "click": function($event) {
              _vm.Deldata(scope.$index, scope.row)
            }
          }
        })]
      }
    }])
  }) : _vm._e(), _vm._v(" "), (_vm.Limits.questionnaire_getReferralUrl) ? _c('el-table-column', {
    attrs: {
      "label": "操作",
      "fixed": "right",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "mini",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              _vm.downQrcode(scope.$index, scope.row)
            }
          }
        }, [_vm._v("生成二维码")])]
      }
    }])
  }) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar downtool",
    attrs: {
      "span": 24
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.DownExcel
    }
  }, [_vm._v("导出到Excel")]), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "span": 20,
      "layout": "total,sizes,prev, pager, next",
      "page-size": _vm.Pagesize,
      "page-sizes": [20, 50],
      "current-page": _vm.Curpage,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "信息修改",
      "visible": _vm.ChangeVisible,
      "width": "800px",
      "top": "3%"
    },
    on: {
      "update:visible": function($event) {
        _vm.ChangeVisible = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.Cform
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "姓名",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    style: (_vm.inputWidth),
    attrs: {
      "auto-complete": "off",
      "size": "small"
    },
    model: {
      value: (_vm.Cform.name),
      callback: function($$v) {
        _vm.$set(_vm.Cform, "name", $$v)
      },
      expression: "Cform.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "性别",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-select', {
    style: (_vm.inputWidth),
    attrs: {
      "placeholder": "请选择性别",
      "size": "small"
    },
    model: {
      value: (_vm.Cform.gender),
      callback: function($$v) {
        _vm.$set(_vm.Cform, "gender", $$v)
      },
      expression: "Cform.gender"
    }
  }, _vm._l((_vm.radioArr.gender), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.lable,
        "value": item.value
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "电话",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    style: (_vm.inputWidth),
    attrs: {
      "type": "phone",
      "auto-complete": "off",
      "size": "small",
      "maxlength": 11
    },
    model: {
      value: (_vm.Cform.phone),
      callback: function($$v) {
        _vm.$set(_vm.Cform, "phone", $$v)
      },
      expression: "Cform.phone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "出生年月",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-date-picker', {
    style: (_vm.inputWidth),
    attrs: {
      "type": "month",
      "placeholder": "选择月",
      "value-format": "timestamp",
      "size": "small"
    },
    model: {
      value: (_vm.Cform.birth),
      callback: function($$v) {
        _vm.$set(_vm.Cform, "birth", $$v)
      },
      expression: "Cform.birth"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "身高(cm)",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-select', {
    style: (_vm.inputWidth),
    attrs: {
      "placeholder": "请选择性别",
      "size": "small"
    },
    model: {
      value: (_vm.Cform.height),
      callback: function($$v) {
        _vm.$set(_vm.Cform, "height", $$v)
      },
      expression: "Cform.height"
    }
  }, _vm._l((101), function(item) {
    return _c('el-option', {
      key: item,
      attrs: {
        "value": item + 99
      }
    }, [_vm._v(_vm._s(item + 99) + "cm")])
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "体重(kg)",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-select', {
    style: (_vm.inputWidth),
    attrs: {
      "placeholder": "请选择性别",
      "size": "small"
    },
    model: {
      value: (_vm.Cform.weight),
      callback: function($$v) {
        _vm.$set(_vm.Cform, "weight", $$v)
      },
      expression: "Cform.weight"
    }
  }, _vm._l((111), function(item) {
    return _c('el-option', {
      key: item,
      attrs: {
        "value": item + 19
      }
    }, [_vm._v(_vm._s(item + 19) + "kg")])
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "腰围(cm)",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-select', {
    style: (_vm.inputWidth),
    attrs: {
      "placeholder": "请选择性别",
      "size": "small"
    },
    model: {
      value: (_vm.Cform.waist),
      callback: function($$v) {
        _vm.$set(_vm.Cform, "waist", $$v)
      },
      expression: "Cform.waist"
    }
  }, _vm._l((201), function(item) {
    return _c('el-option', {
      key: item,
      attrs: {
        "value": item + 19
      }
    }, [_vm._v(_vm._s(item + 19) + "cm")])
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "学历",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-select', {
    style: (_vm.inputWidth),
    attrs: {
      "placeholder": "请选择性别",
      "size": "small"
    },
    model: {
      value: (_vm.Cform.edu),
      callback: function($$v) {
        _vm.$set(_vm.Cform, "edu", $$v)
      },
      expression: "Cform.edu"
    }
  }, _vm._l((_vm.radioArr.edu), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.lable,
        "value": item.value
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "工作",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-select', {
    style: (_vm.inputWidth),
    attrs: {
      "placeholder": "请选择性别",
      "size": "small"
    },
    model: {
      value: (_vm.Cform.job),
      callback: function($$v) {
        _vm.$set(_vm.Cform, "job", $$v)
      },
      expression: "Cform.job"
    }
  }, _vm._l((_vm.radioArr.job), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.lable,
        "value": item.value
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "受伤时间",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-date-picker', {
    style: (_vm.inputWidth),
    attrs: {
      "type": "month",
      "placeholder": "选择月",
      "value-format": "timestamp",
      "size": "small"
    },
    model: {
      value: (_vm.Cform.injurytime),
      callback: function($$v) {
        _vm.$set(_vm.Cform, "injurytime", $$v)
      },
      expression: "Cform.injurytime"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "地址",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-cascader', {
    style: (_vm.inputWidth),
    attrs: {
      "size": "small",
      "expand-trigger": "hover",
      "options": _vm.Addoptions
    },
    model: {
      value: (_vm.Cform.addr),
      callback: function($$v) {
        _vm.$set(_vm.Cform, "addr", $$v)
      },
      expression: "Cform.addr"
    }
  })], 1), _vm._v(" "), _c('h3', [_vm._v("脊髓损伤")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "颈椎段",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-checkbox-group', {
    model: {
      value: (_vm.Cform.jzarr),
      callback: function($$v) {
        _vm.$set(_vm.Cform, "jzarr", $$v)
      },
      expression: "Cform.jzarr"
    }
  }, _vm._l((_vm.radioArr.AQ11), function(item) {
    return _c('el-checkbox', {
      key: item.value,
      attrs: {
        "label": item.value
      }
    }, [_vm._v(_vm._s(item.text))])
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "胸椎段",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-checkbox-group', {
    model: {
      value: (_vm.Cform.jzarr),
      callback: function($$v) {
        _vm.$set(_vm.Cform, "jzarr", $$v)
      },
      expression: "Cform.jzarr"
    }
  }, _vm._l((_vm.radioArr.AQ12), function(item) {
    return _c('el-checkbox', {
      key: item.value,
      attrs: {
        "label": item.value
      }
    }, [_vm._v(_vm._s(item.text))])
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "腰椎段",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-checkbox-group', {
    model: {
      value: (_vm.Cform.jzarr),
      callback: function($$v) {
        _vm.$set(_vm.Cform, "jzarr", $$v)
      },
      expression: "Cform.jzarr"
    }
  }, _vm._l((_vm.radioArr.AQ13), function(item) {
    return _c('el-checkbox', {
      key: item.value,
      attrs: {
        "label": item.value
      }
    }, [_vm._v(_vm._s(item.text))])
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "腰椎段",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-checkbox-group', {
    model: {
      value: (_vm.Cform.jzarr),
      callback: function($$v) {
        _vm.$set(_vm.Cform, "jzarr", $$v)
      },
      expression: "Cform.jzarr"
    }
  }, _vm._l((_vm.radioArr.AQ14), function(item) {
    return _c('el-checkbox', {
      key: item.value,
      attrs: {
        "label": item.value
      }
    }, [_vm._v(_vm._s(item.text))])
  }))], 1), _vm._v(" "), _c('h3', [_vm._v("其他病种")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "其他病种",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-checkbox-group', {
    model: {
      value: (_vm.Cform.otarr2),
      callback: function($$v) {
        _vm.$set(_vm.Cform, "otarr2", $$v)
      },
      expression: "Cform.otarr2"
    }
  }, _vm._l((_vm.radioArr.AQ2), function(item) {
    return _c('el-checkbox', {
      key: item.value,
      attrs: {
        "label": item.value
      }
    }, [_vm._v(_vm._s(item.text))])
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "其他",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    style: (_vm.inputWidth),
    attrs: {
      "auto-complete": "off",
      "size": "small"
    },
    model: {
      value: (_vm.Cform.otherInput),
      callback: function($$v) {
        _vm.$set(_vm.Cform, "otherInput", $$v)
      },
      expression: "Cform.otherInput"
    }
  })], 1), _vm._v(" "), _c('h3', [_vm._v("适用判断")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "近3个月站立训练",
      "label-width": _vm.formLabelWidth2
    }
  }, [_c('el-select', {
    style: (_vm.inputWidth),
    attrs: {
      "placeholder": "请选择性别",
      "size": "small"
    },
    model: {
      value: (_vm.Cform.apply1),
      callback: function($$v) {
        _vm.$set(_vm.Cform, "apply1", $$v)
      },
      expression: "Cform.apply1"
    }
  }, _vm._l((_vm.radioArr.AQ31), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.lable,
        "value": item.value
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "近3个月骨密度",
      "label-width": _vm.formLabelWidth2
    }
  }, [_c('el-select', {
    style: (_vm.inputWidth),
    attrs: {
      "placeholder": "请选择性别",
      "size": "small"
    },
    model: {
      value: (_vm.Cform.apply2),
      callback: function($$v) {
        _vm.$set(_vm.Cform, "apply2", $$v)
      },
      expression: "Cform.apply2"
    }
  }, _vm._l((_vm.radioArr.AQ32), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.lable,
        "value": item.value
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "痉挛等级",
      "label-width": _vm.formLabelWidth2
    }
  }, [_c('el-select', {
    style: (_vm.inputWidth),
    attrs: {
      "placeholder": "请选择性别",
      "size": "small"
    },
    model: {
      value: (_vm.Cform.apply3),
      callback: function($$v) {
        _vm.$set(_vm.Cform, "apply3", $$v)
      },
      expression: "Cform.apply3"
    }
  }, _vm._l((_vm.radioArr.AQ33), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.lable,
        "value": item.value
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "上肢及手功能等级",
      "label-width": _vm.formLabelWidth2
    }
  }, [_c('el-select', {
    style: (_vm.inputWidth),
    attrs: {
      "placeholder": "请选择性别",
      "size": "small"
    },
    model: {
      value: (_vm.Cform.apply4),
      callback: function($$v) {
        _vm.$set(_vm.Cform, "apply4", $$v)
      },
      expression: "Cform.apply4"
    }
  }, _vm._l((_vm.radioArr.AQ34), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.lable,
        "value": item.value
      }
    })
  }))], 1), _vm._v(" "), _c('h3', [_vm._v("禁忌情况")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "体位性低血压",
      "label-width": _vm.formLabelWidth2
    }
  }, [_c('el-select', {
    style: (_vm.inputWidth),
    attrs: {
      "placeholder": "请选择性别",
      "size": "small"
    },
    model: {
      value: (_vm.Cform.tabu1),
      callback: function($$v) {
        _vm.$set(_vm.Cform, "tabu1", $$v)
      },
      expression: "Cform.tabu1"
    }
  }, _vm._l((_vm.radioArr.AQ41), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.lable,
        "value": item.value
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "脊柱侧弯？",
      "label-width": _vm.formLabelWidth2
    }
  }, [_c('el-select', {
    style: (_vm.inputWidth),
    attrs: {
      "placeholder": "请选择性别",
      "size": "small"
    },
    model: {
      value: (_vm.Cform.tabu2),
      callback: function($$v) {
        _vm.$set(_vm.Cform, "tabu2", $$v)
      },
      expression: "Cform.tabu2"
    }
  }, _vm._l((_vm.radioArr.AQ42), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.lable,
        "value": item.value
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "关节严重变形",
      "label-width": _vm.formLabelWidth2
    }
  }, [_c('el-select', {
    style: (_vm.inputWidth),
    attrs: {
      "placeholder": "请选择性别",
      "size": "small"
    },
    model: {
      value: (_vm.Cform.tabu3),
      callback: function($$v) {
        _vm.$set(_vm.Cform, "tabu3", $$v)
      },
      expression: "Cform.tabu3"
    }
  }, _vm._l((_vm.radioArr.AQ43), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.lable,
        "value": item.value
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "长短腿",
      "label-width": _vm.formLabelWidth2
    }
  }, [_c('el-select', {
    style: (_vm.inputWidth),
    attrs: {
      "placeholder": "请选择性别",
      "size": "small"
    },
    model: {
      value: (_vm.Cform.tabu4),
      callback: function($$v) {
        _vm.$set(_vm.Cform, "tabu4", $$v)
      },
      expression: "Cform.tabu4"
    }
  }, _vm._l((_vm.radioArr.AQ44), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.lable,
        "value": item.value
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "认知障碍",
      "label-width": _vm.formLabelWidth2
    }
  }, [_c('el-select', {
    style: (_vm.inputWidth),
    attrs: {
      "placeholder": "请选择性别",
      "size": "small"
    },
    model: {
      value: (_vm.Cform.tabu5),
      callback: function($$v) {
        _vm.$set(_vm.Cform, "tabu5", $$v)
      },
      expression: "Cform.tabu5"
    }
  }, _vm._l((_vm.radioArr.AQ45), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.lable,
        "value": item.value
      }
    })
  }))], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.ChangeVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.subChangeData
    }
  }, [_vm._v("确认修改并提交")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "二维码",
      "visible": _vm.qrcodeVisible,
      "width": "300px"
    },
    on: {
      "update:visible": function($event) {
        _vm.qrcodeVisible = $event
      }
    }
  }, [_c('div', {
    attrs: {
      "id": "qrcodediv"
    }
  }), _vm._v(" "), _c('el-form', [_c('el-form-item', {
    attrs: {
      "label": "二维码命名：",
      "label-width": "120"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.qrcodeName),
      callback: function($$v) {
        _vm.qrcodeName = $$v
      },
      expression: "qrcodeName"
    }
  })], 1)], 1), _vm._v(" "), _c('a', {
    attrs: {
      "id": "download",
      "download": _vm.qrcodeName
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.qrcodeVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.downIt
    }
  }, [_vm._v("下 载")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5aa9ced2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/CustomerInformation.vue
// module id = 1275
// module chunks = 1